import React from "react";
import { Table } from "react-bootstrap";
import PropTypes from "prop-types";

const TableSkeleton = ({ rows = 5, headers = 5 }) => {
  return (
    <Table
      striped
      responsive
      className="w-full min-w-full table-auto border-collapse border border-gray-200 dark:border-gray-800"
    >
      <thead className="rounded-lg">
        <tr className="border dark:border-gray-800/50">
          {Array.from({ length: headers }).map((_, i) => (
            <th key={i} className="p-2 sm:p-3 lg:p-4">
              <div className="h-3 sm:h-4 w-full animate-pulse rounded bg-gray-200 dark:bg-gray-700"></div>
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {Array.from({ length: rows }).map((_, index) => (
          <tr
            key={index}
            className={
              index < rows - 1 ? "border dark:border-gray-800/50" : "border-b-0"
            }
          >
            <td className="p-2 sm:p-3 lg:p-4">
              <div className="h-3 sm:h-4 w-full animate-pulse rounded bg-gray-200 dark:bg-gray-700"></div>
            </td>

            <td className="p-2 sm:p-3 lg:p-4">
              <div className="flex items-center gap-1 sm:gap-2 lg:gap-3 w-full">
                <div className="h-5 w-5 sm:h-6 sm:w-6 lg:h-8 lg:w-8 animate-pulse rounded-full bg-gray-200 dark:bg-gray-700 flex-shrink-0"></div>
                <div className="h-3 sm:h-4 w-full animate-pulse rounded bg-gray-200 dark:bg-gray-700"></div>
              </div>
            </td>

            <td className="p-2 sm:p-3 lg:p-4">
              <div className="h-3 sm:h-4 w-full animate-pulse rounded bg-gray-200 dark:bg-gray-700"></div>
            </td>

            <td className="p-2 sm:p-3 lg:p-4">
              <div className="h-5 sm:h-6 w-full max-w-[80px] sm:max-w-[100px] animate-pulse rounded-full bg-gray-200 dark:bg-gray-700"></div>
            </td>

            <td className="p-2 sm:p-3 lg:p-4">
              <div className="h-3 sm:h-4 w-full animate-pulse rounded bg-gray-200 dark:bg-gray-700"></div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

TableSkeleton.propTypes = {
  rows: PropTypes.number,
  headers: PropTypes.number,
};

export default TableSkeleton;
